import { render } from "./RegisterCourseDialog.vue?vue&type=template&id=f50a4d62"
import script from "./RegisterCourseDialog.vue?vue&type=script&lang=js"
export * from "./RegisterCourseDialog.vue?vue&type=script&lang=js"

import exportComponent from "/Users/andreaskura/repos/cio-online-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__